// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".variable_box[data-v-031c3c4a] {\n  padding: 0 20px;\n}\n.variable_box .top[data-v-031c3c4a] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.variable_box .text[data-v-031c3c4a] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
